import React, { useContext, useState, useMemo } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../hooks/useAuth'

import { AppContext } from '../../contexts/App';

import { SignUp } from './SignUp';
import posthog from 'posthog-js';


const Wrapper = styled.div`
    background: rgba(0, 0, 0, 0.33);
    /* background: white; */
    backdrop-filter: blur(6px);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    min-height: calc((var(--vh, 1vh)*100));
    max-height: calc((var(--vh, 1vh)*100));
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    & > div {
        box-sizing: border-box;
        border-radius: 6px;
        background: white;
        padding: 3rem;
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        @media only screen and (max-width: 768px) {
            width: 100%;
            padding: 1rem;
            height: 100vh;
            border-radius: 0px;
        }
    }
`

const Modal = (props) => {
    const { loading } = useContext(AppContext);
    const { user, isAuthenticated } = useAuth()
    const { showModal, toggleModal } = useContext(AppContext)

    if (!isAuthenticated) {
        posthog.capture('Signup View');
    }
    
    return !isAuthenticated && (
        <Wrapper>
            <div>
                <SignUp/>
            </div>
        </Wrapper>
    )
}

export default Modal;